import { z } from 'zod';
import dayjs from 'dayjs';
import {
  EMPTY_FIELD_MESSAGE,
  validateSpace,
  validateTextEn,
} from '@Utils/validation';

enum OPERATION_PLAN_MESSAGE {
  DETAIL = 'กรุณาระบุเป้าหมาย',
  DETAIL_EN = 'กรุณาระบุเป้าหมายเป็นภาษาอังกฤษ',
  DATE = 'กรุณาเลือกระยะเวลาเป้าหมาย',
  CRITERIA = 'กรุณาระบุเกณฑ์การวัดผล',
  CRITERIA_EN = 'กรุณาระบุเกณฑ์การวัดผลเป็นภาษาอังกฤษ',
}

const IndicatorSchema = z.object({
  criteriaTh: z
    .string({ message: OPERATION_PLAN_MESSAGE.CRITERIA })
    .min(1, { message: OPERATION_PLAN_MESSAGE.CRITERIA })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  criteriaEn: z
    .string({ message: OPERATION_PLAN_MESSAGE.CRITERIA })
    .min(1, { message: OPERATION_PLAN_MESSAGE.CRITERIA })
    .regex(validateTextEn, {
      message: OPERATION_PLAN_MESSAGE.CRITERIA_EN,
    })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
});

export const ModalGoalValidationSchema = z
  .object({
    detailTh: z
      .string({ message: OPERATION_PLAN_MESSAGE.DETAIL })
      .min(1, { message: OPERATION_PLAN_MESSAGE.DETAIL })
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
    detailEn: z
      .string({ message: OPERATION_PLAN_MESSAGE.DETAIL })
      .min(1, { message: OPERATION_PLAN_MESSAGE.DETAIL })
      .regex(validateTextEn, {
        message: OPERATION_PLAN_MESSAGE.DETAIL_EN,
      })
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
    durationType: z.enum(['WITHIN_MONTH', 'MONTH_PERIOD']),
    startDate: z
      .custom((value) => dayjs.isDayjs(value) && value.isValid(), {
        message: OPERATION_PLAN_MESSAGE.DATE,
      })
      .nullable()
      .optional(),
    endDate: z.custom((value) => dayjs.isDayjs(value) && value.isValid(), {
      message: OPERATION_PLAN_MESSAGE.DATE,
    }),
    indicators: z.array(IndicatorSchema),
  })
  .superRefine((data, ctx) => {
    if (data.durationType === 'MONTH_PERIOD' && !data.startDate) {
      ctx.addIssue({
        code: 'custom',
        path: ['startDate'],
        message: OPERATION_PLAN_MESSAGE.DATE,
      });
    }
  });
